import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './disability.reducer';

export const DisabilityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const disabilityEntity = useAppSelector(state => state.disability.entity);
  const loading = useAppSelector(state => state.disability.loading);
  const updating = useAppSelector(state => state.disability.updating);
  const updateSuccess = useAppSelector(state => state.disability.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/disability${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.disabledUnderDisabilityAct !== undefined && typeof values.disabledUnderDisabilityAct !== 'number') {
      values.disabledUnderDisabilityAct = Number(values.disabledUnderDisabilityAct);
    }
    if (values.notDisabledUnderDisabilityAct !== undefined && typeof values.notDisabledUnderDisabilityAct !== 'number') {
      values.notDisabledUnderDisabilityAct = Number(values.notDisabledUnderDisabilityAct);
    }

    const entity = {
      ...disabilityEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...disabilityEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.disability.home.createOrEditLabel" data-cy="DisabilityCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.disability.home.createOrEditLabel">Create or edit a Disability</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="disability-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.disability.geographicLevel')}
                id="disability-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.disability.date')}
                id="disability-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.disability.geography')}
                id="disability-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.disability.geographyCode')}
                id="disability-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.disability.totalAllUsualResidents')}
                id="disability-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.disability.disabledUnderDisabilityAct')}
                id="disability-disabledUnderDisabilityAct"
                name="disabledUnderDisabilityAct"
                data-cy="disabledUnderDisabilityAct"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.disability.notDisabledUnderDisabilityAct')}
                id="disability-notDisabledUnderDisabilityAct"
                name="notDisabledUnderDisabilityAct"
                data-cy="notDisabledUnderDisabilityAct"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/disability" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DisabilityUpdate;
